/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaEventHandler.on('modal.hide', function (e) {
        e.modal.element.parentElement.parentElement.parentElement.classList.add('exiting');
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
